// extracted by mini-css-extract-plugin
module.exports = {"RestaurantOpenClosedBlurb":"RestaurantOpenClosedBlurb_RestaurantOpenClosedBlurb__tLUVo","dot":"RestaurantOpenClosedBlurb_dot__GrV_i","text":"RestaurantOpenClosedBlurb_text___zzbL"};